import * as React from 'react';
import type { OnlinePlannerSubject } from '../../Interfaces/OnlinePlannerSubject';
import { PlannerBookmarks } from '../PlannerBookmarks/PlannerBookmarks';
import type { PlannerContentProps } from '../PlannerContent/PlannerContent';
import { PlannerContent } from '../PlannerContent/PlannerContent';
import type { OnlineStudyPlannerSectionTranslations } from '~/Pages/OnlineStudyPage/ViewModel/StudyPlanner/TranslationsModels/OnlineStudyPlannerSectionTranslations.csharp';
import type { LinkViewModel } from '~/Partials/Link/LinkViewModel.csharp';
import { PlannerContextProvider } from './Context/PlannerContextProvider';
import { PlannerContextTranslationsProvider } from './Context/PlannerTranslationsContextProvider';
import type { ElectiveGroupCode, ElectiveGroupDescriptor, OnlinePlannerTimeDetails } from './Context/types';
import { getBookmarks, getFilters } from './utils';

export interface PlannerProps extends Pick<PlannerContentProps, 'onlineApplicationFormUrl' | 'popup'> {
    translations: OnlineStudyPlannerSectionTranslations;
    subjects: OnlinePlannerSubject[];
    electiveGroupDescriptors: Map<ElectiveGroupCode, ElectiveGroupDescriptor>;
    timeDetails: OnlinePlannerTimeDetails;
    nonPurchasableSubjectsLink?: LinkViewModel;
    className?: string;
}

export const Planner: React.FC<PlannerProps> = props => {
    const { className, translations, onlineApplicationFormUrl, popup, subjects, ...restContextProps } = props;

    const { tabs, filters } = translations;

    const filterOptions = getFilters(subjects, filters);
    const bookmarks = getBookmarks(subjects, tabs);

    return (
        <PlannerContextProvider
            subjects={subjects}
            filterOptions={filterOptions}
            bookmarks={bookmarks}
            {...restContextProps}
        >
            <PlannerContextTranslationsProvider translations={translations}>
                <PlannerBookmarks className={className}>
                    <PlannerContent onlineApplicationFormUrl={onlineApplicationFormUrl} popup={popup} />
                </PlannerBookmarks>
            </PlannerContextTranslationsProvider>
        </PlannerContextProvider>
    );
};
